"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const esprima = __importStar(require("esprima"));
/**
 * identifierProcessor is responsible for handling all non-quoted strings, e.g. variables.
 */
function identifierProcessor(cache, identifier, object) {
    var _a, _b, _c, _d;
    try {
        if (object.value.type === esprima.Syntax.ArrayExpression ||
            (object.value.type === esprima.Syntax.UnaryExpression &&
                object.value.argument.type === esprima.Syntax.ArrayExpression) ||
            object.value.type === esprima.Syntax.CallExpression ||
            (object.value.type === esprima.Syntax.UnaryExpression &&
                object.value.argument.type === esprima.Syntax.CallExpression)) {
            return { type: getTypeMapping(identifier.name) };
        }
        else {
            cache.properties[object.key.name] = {
                type: getTypeMapping((_a = identifier) === null || _a === void 0 ? void 0 : _a.name),
            };
        }
    }
    catch (error) {
        throw new Error(`Line ${(_d = (_c = (_b = object) === null || _b === void 0 ? void 0 : _b.loc) === null || _c === void 0 ? void 0 : _c.start) === null || _d === void 0 ? void 0 : _d.line}: ${error.message}`);
    }
    return cache;
}
const allowedDataTypes = [
    //
    "s",
    "string",
    "i",
    "integer",
    "n",
    "number",
    "b",
    "boolean",
];
function getTypeMapping(shortType) {
    if (!allowedDataTypes.includes(shortType)) {
        throw new Error(`ssg error: '${shortType}' is not a valid data type`);
    }
    const typeMapping = {
        s: "string",
        i: "integer",
        n: "number",
        b: "boolean",
    };
    return typeMapping[shortType] || shortType;
}
/**
 * unaryExpressionProcessor is responsible for handling "!"
 */
function unaryExpressionProcessor(cache, unary, object) {
    var _a, _b, _c, _d;
    if (unary.operator === "!") {
        cache.required = [...(((_a = cache) === null || _a === void 0 ? void 0 : _a.required) || []), object.key.name];
        if (unary.argument.type === esprima.Syntax.Identifier) {
            return identifierProcessor(cache, unary.argument, object);
        }
        if (unary.argument.type === esprima.Syntax.ObjectExpression) {
            return objectExpressionProcessor(cache, unary.argument, object);
        }
        if (unary.argument.type === esprima.Syntax.ArrayExpression) {
            return arrayExpressionProcessor(cache, unary.argument, object);
        }
        if (unary.argument.type === esprima.Syntax.CallExpression) {
            return callExpressionProcessor(cache, unary.argument, object);
        }
    }
    throw new Error(`Line ${(_d = (_c = (_b = object) === null || _b === void 0 ? void 0 : _b.loc) === null || _c === void 0 ? void 0 : _c.start) === null || _d === void 0 ? void 0 : _d.line}: Syntax error`);
}
/**
 * objectExpressionProcessor is responsible for handling objects.
 */
function objectExpressionProcessor(cache, obj, object) {
    if (object.value.type === esprima.Syntax.ArrayExpression ||
        (object.value.type === esprima.Syntax.UnaryExpression &&
            object.value.argument.type === esprima.Syntax.ArrayExpression) ||
        object.value.type === esprima.Syntax.CallExpression ||
        (object.value.type === esprima.Syntax.UnaryExpression &&
            object.value.argument.type === esprima.Syntax.CallExpression)) {
        return {
            type: "object",
            ...obj.properties.reduce(reducer, undefined),
        };
    }
    cache.properties[object.key.name] = {
        type: "object",
        ...obj.properties.reduce(reducer, undefined),
    };
    return cache;
}
/**
 * arrayExpressionProcessor is responsible for handling arrays.
 */
function arrayExpressionProcessor(cache, array, object) {
    cache.properties[object.key.name] = {
        type: "array",
        items: (() => {
            const element = array.elements[0];
            if (!element) {
                return {};
            }
            switch (element.type) {
                case esprima.Syntax.Identifier:
                    return identifierProcessor({}, element, object);
                case esprima.Syntax.ObjectExpression:
                    return objectExpressionProcessor({}, element, object);
                case esprima.Syntax.CallExpression:
                    return callExpressionProcessor(null, element, object);
            }
        })(),
    };
    return cache;
}
const allowedFunctionalKeywords = [
    //
    "oneOf",
    "allOf",
    "anyOf",
    "enumOf",
];
const allowedEnumTypes = ["string", "s", "number", "n", "integer", "i"];
function validateValuesAgainstType(type, values) {
    if (allowedEnumTypes.includes(type)) {
        values.forEach((value) => {
            if (!allowedEnumTypes.includes(typeof value)) {
                throw new Error(`ssg error: enum type mismatch, expected type is ${type}`);
            }
        });
    }
}
/**
 * callExpressionProcessor is responsible for handling function calls. e.g. oneOf(string, number)
 */
function callExpressionProcessor(cache, call, object) {
    var _a, _b, _c;
    if (!allowedFunctionalKeywords.includes(call.callee.name)) {
        throw new Error(`Line ${(_c = (_b = (_a = object) === null || _a === void 0 ? void 0 : _a.loc) === null || _b === void 0 ? void 0 : _b.start) === null || _c === void 0 ? void 0 : _c.line}: '${call.callee.name}' is an invalid keyword`);
    }
    /**
     * oneOf, allOf and anyOf keywords share same schema structure, so can be used together here.
     */
    if (allowedFunctionalKeywords.includes(call.callee.name)) {
        /**
         * 1. When array items are being reduced, cache is not passed to generate new object.
         * 2. When the callExpression is inside an arrayExpression, we need to return new object.
         * 3. When there's a unaryExpression followed by arrayExpression and inside arrayExpression there's a callExpression, we need to return new object.
         */
        if (!cache && //
            (object.value.type === esprima.Syntax.ArrayExpression ||
                (object.value.type === esprima.Syntax.UnaryExpression &&
                    object.value.argument.type === esprima.Syntax.ArrayExpression))) {
            return {
                [call.callee.name]: call.arguments.map((argument) => {
                    if (argument.type === esprima.Syntax.Identifier) {
                        return identifierProcessor({}, argument, object);
                    }
                    if (argument.type === esprima.Syntax.ObjectExpression) {
                        return objectExpressionProcessor({}, argument, object);
                    }
                }),
            };
        }
        /**
         * If the callExpression is outside the arrayExpression, cache will be passed. So we need to update that and return back.
         */
        cache.properties[object.key.name] = {
            [call.callee.name]: call.arguments.map((argument) => {
                if (argument.type === esprima.Syntax.Identifier) {
                    return identifierProcessor({}, argument, object);
                }
                if (argument.type === esprima.Syntax.ObjectExpression) {
                    return objectExpressionProcessor({}, argument, object);
                }
            }),
        };
    }
    if (["enumOf"].includes(call.callee.name)) {
        const [typeArg, ...valueArgs] = call.arguments;
        validateValuesAgainstType(typeArg.name, valueArgs.map((arg) => arg.value));
        const enumValues = valueArgs.map((argument) => {
            if (argument.type === esprima.Syntax.Literal) {
                return argument.value;
            }
        });
        cache.properties[object.key.name] = {
            ...identifierProcessor(undefined, typeArg, object),
            enum: enumValues,
        };
    }
    return cache;
}
function filterCache(cache) {
    var _a;
    if (typeof cache.required !== "undefined" && !((_a = cache.required) === null || _a === void 0 ? void 0 : _a.length)) {
        delete cache.required;
    }
    return cache;
}
/**
 * reducer is responsible for reducing the AST into Schema Object.
 */
const reducer = (cache = {
    type: "object",
    required: [],
    properties: {},
}, obj) => {
    // if (obj.key.name === "$meta") {
    // 	return {
    // 		...obj.value.properties.reduce((meta, prop) => {
    // 			meta[prop.key.name] = prop.value.value;
    // 			return meta;
    // 		}, {}),
    // 		...cache,
    // 	};
    // }
    if (obj.value.type === esprima.Syntax.Identifier) {
        return filterCache(identifierProcessor(cache, obj.value, obj));
    }
    if (obj.value.type === esprima.Syntax.UnaryExpression) {
        return filterCache(unaryExpressionProcessor(cache, obj.value, obj));
    }
    if (obj.value.type === esprima.Syntax.ObjectExpression) {
        return filterCache(objectExpressionProcessor(cache, obj.value, obj));
    }
    if (obj.value.type === esprima.Syntax.ArrayExpression) {
        return arrayExpressionProcessor(cache, obj.value, obj);
    }
    if (obj.value.type === esprima.Syntax.CallExpression) {
        return filterCache(callExpressionProcessor(cache, obj.value, obj));
    }
};
function ssgToOASParser(str) {
    const parsedScript = esprima.parseScript(`(${str})`, { loc: false });
    const allObjectProperties = parsedScript.body[0].expression.properties;
    //console.log('123',JSON.stringify(allObjectProperties,null,2));process.exit();
    return allObjectProperties.reduce(reducer, undefined);
}
exports.ssgToOASParser = ssgToOASParser;
//# sourceMappingURL=ssg.js.map